export const bureauServices = [
  {
    icon: "/images/bureau/globe.svg",
    name: "Outsourcing",
    description:
      "Time and cost-saving outsourcing solutions for more focused scaling operations and business expansion.",
  },
  {
    icon: "/images/bureau/staffing.svg",
    name: "Outstaffing",
    description:
      "We offer a flexible hiring model and skilled professionals precisely aligned with your business’s core needs.",
  },
  {
    icon: "/images/bureau/parachuteBag.svg",
    name: "Soft Landing",
    description:
      "Simplify your market entry with tailored strategies, market demand analysis, and insights into your target audience.",
  },
  {
    icon: "/images/bureau/laptop.svg",
    name: "Digital Transformation",
    description:
      "Streamlining business processes and scaling operations with our digital solutions to meet market expectations.",
  },
];
